// Subcategory Banners Carousel JS
document.addEventListener('DOMContentLoaded', function () {
  var swiperWrappers = document.querySelectorAll('.subcategory-banners .swiper-wrapper');
  if (!swiperWrappers) return; // Exit if swiperWrapper is not found

  const subcategoryBannerCarousels = document.querySelectorAll('.subcategory-banners:not(.initialized)');
  subcategoryBannerCarousels.forEach(carousel => {
    const subcategoryBanners = carousel.querySelectorAll('.subcategory-banner');
    const headingText = carousel.querySelector('.subcategory-banners__heading h2').textContent.trim();
    // console.log(`Subcategory Banners Carousel initialized with heading: ${headingText}`);
    subcategoryBanners.forEach(banner => {
      const bannerUrl = banner.getAttribute('href');
      const bannerTitle = banner.getAttribute('title');
      // const ariaLabel = banner.getAttribute('aria-label');

      // Add click event listener to each banner
      banner.addEventListener('click', function (event) {
        // Log the click event to Google Analytics
        if (typeof gtag === 'function') {
          event.preventDefault(); // Prevent default link behavior
          // console.log(`Banner clicked: ${bannerTitle} - URL: ${bannerUrl} - Aria Label: ${ariaLabel} - Heading: ${headingText}`);
          gtag('event', 'click', {
            'event_category': `Subcategory Banner - ${headingText}`,
            'event_label': `${bannerTitle}`,
            'event_action': 'click',
            'event_value': bannerUrl,
            'event_callback': function () {
              window.location = bannerUrl; // Redirect after logging the event
            },
            'event_timeout': 2000  // fallback if callback doesn’t fire
          });
        }
      });
    });
    carousel.classList.add('initialized');
  });

  swiperWrappers.forEach(swiperWrapper => {
    const bannerInterval = swiperWrapper.getAttribute('data-interval');
    const bannerSpeed = swiperWrapper.getAttribute('data-transition');
    const sectionId = swiperWrapper.getAttribute('data-section-id');
    const autoplay = swiperWrapper.getAttribute('data-autoplay') === 'true';
    const equalizeHeight = swiperWrapper.getAttribute('data-equal-height') === 'true';
    const slidesPerViewMobile = swiperWrapper.getAttribute('data-slides-per-view-mobile');
    const addScrollBarClass = (swiper) => {
      if (swiper.isBeginning && swiper.isEnd) //means no need for scrollbar
        swiper.el.classList.remove('visible-scrollbar');
      else
        swiper.el.classList.add('visible-scrollbar');
    }
    const onSlideChange = (swiper) => {
      if (swiper.isBeginning)
        swiper.navigation.prevEl?.classList?.add('swiper-button-disabled', 'hidden');
      else
        swiper.navigation.prevEl?.classList?.remove('swiper-button-disabled', 'hidden');
      if (swiper.isEnd)
        swiper.navigation.nextEl?.classList?.add('swiper-button-disabled', 'hidden');
      else
        swiper.navigation.nextEl?.classList?.remove('swiper-button-disabled', 'hidden');
    }
    const setSwiperHeight = (swiper) => {
      const wrapperHeight = swiper?.wrapperEl?.offsetHeight;
      wrapperHeight && swiper?.wrapperEl?.style?.setProperty('height', Math.ceil(wrapperHeight) + 'px');
    }
    const unsetSwiperHeight = (swiper) => {
      swiper?.wrapperEl?.style?.removeProperty('height');
    }
    var swiper = new Swiper(`.subcategory-banners.${sectionId} .swiper-container:not(.no-swiper):not(.no-scrollbar)`, {
      slidesPerView: 8,
      spaceBetween: 10,
      loop: false, // Enables infinite scrolling
      autoplay: autoplay ? {
        delay: bannerInterval,
        disableOnInteraction: false,
      } : false,
      scrollbar: {
        el: `.subcategory-banners.${sectionId} .swiper-scrollbar`,
        hide: false,
        draggable: true, // Enable dragging
        snapOnRelease: true, // Optional: snaps to the closest slide after release
      },
      navigation: {
        nextEl: `.subcategory-banners.${sectionId} .swiper-button-next`,
        prevEl: `.subcategory-banners.${sectionId} .swiper-button-prev`
      },
      speed: bannerSpeed,
      breakpoints: {
        0: {
          slidesPerView: slidesPerViewMobile ? parseInt(slidesPerViewMobile) : 3,
          spaceBetween: 10,
        },
        550: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 6,
          spaceBetween: 10,
        },
        1280: {
          slidesPerView: 7,
          spaceBetween: 10,
        },
        1440: {
          slidesPerView: 8,
          spaceBetween: 10,
        }
      },
      on: {
        init: function () {
          swiperWrapper.classList.add('initialized');
          onSlideChange(this);
          addScrollBarClass(this);
          equalizeHeight && setSwiperHeight(this);
        },
        resize: function () {
          addScrollBarClass(this);
          equalizeHeight && setSwiperHeight(this);
        },
        beforeInit: unsetSwiperHeight,
        beforeResize: unsetSwiperHeight,
        slideChange: onSlideChange
      }
    });
  });

});